(function () {
  'use strict';
  function initCommunityStories(root) {
    var viewport = root.querySelector('[data-mc-community-viewport]');
    var track = root.querySelector('.mc-community-stories__track');
    if (!viewport || !track) return;

    // Never pause — strip any leftover pause class from older JS
    root.classList.remove('is-paused');

    // Wrap track in marquee shell and clone once for seamless -50% loop
    var marquee = viewport.querySelector('.mc-community-stories__marquee');
    if (!marquee) {
      marquee = document.createElement('div');
      marquee.className = 'mc-community-stories__marquee';
      viewport.insertBefore(marquee, track);
      marquee.appendChild(track);
    }

    Array.prototype.slice.call(marquee.querySelectorAll('[data-mc-community-clone]')).forEach(function (n) {
      n.parentNode.removeChild(n);
    });

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var clone = track.cloneNode(true);
    clone.setAttribute('data-mc-community-clone', 'true');
    clone.setAttribute('aria-hidden', 'true');
    Array.prototype.slice.call(clone.querySelectorAll('[id]')).forEach(function (el) {
      el.removeAttribute('id');
    });
    marquee.appendChild(clone);
  }

  function boot() {
    document.querySelectorAll('[data-mc-community-stories]').forEach(initCommunityStories);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
}());
